import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import * as Styles from './service-point-container.module.scss'

export function ServicePointContainer({ ...props }) {
  return (
    <div
      {...props}
      className={classNames(Styles.pointContainer, props.className)}
    >
      <div className={Styles.pointContainer__header}>
        <p className="sans-serif">point</p>
        <h2>Uniforce導入のメリット</h2>
      </div>
      <ul>
        <li>面倒なタスク作成と納期設定は必要ありません。</li>
        <li>開示業務をチームメンバー全員で共有し、業務を標準化できます。</li>
        <li>進捗を見える化し、管理の負担を減らすことができます。</li>
      </ul>
      <div className={Styles.picture}>
        <StaticImage src="../../images/contact_image_point.png" height={312} />
      </div>
    </div>
  )
}
